import { render } from "./App.vue?vue&type=template&id=3a063a11"
const script = {}

import "./App.vue?vue&type=style&index=0&lang=less"
script.render = render

export default script